import { Toast, Dialog,Field, CellGroup } from 'vant';
import wx from 'jweixin-1.6.0';
import comment from "../../util/comment"

var that;
var timer;
export default {
    setup() {
        const onClickLeft = () => history.back();
        return {
            onClickLeft,
        };
    },
    data() {
        return {
            dhInfoList: [],
            test:"0",
            user:{}
        };
    },

    created() {
        that = this;
        if (this.$route.query.memberId != undefined) {
            this.getMemberById();
        }

    },
    
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer); //关闭
        } //利用vue的生命周期函数
    },

    methods: {
        // 根据会员ID获取会员对象 API
        getMemberById: function() {
            this.$api.getMemberById({
                params: {
                    'memberId': this.$route.query.memberId + '',
                },
                success: function(res) {
                    // console.log(res.data, "res.data");
                    this.user = res.data;

                }.bind(this),
                fail: function(res) {
                    console.log(":::fail", res)

                }
            })
        },
        exposureSave() {
            console.log(this.test);
            console.log(this.$route.query.memberId);
            var title =  document.getElementById("myInput").value;
            var content = document.getElementById("myText").value;
            var phone = document.getElementById("myPhone").value;
            if(phone == "" || phone == undefined){
                Dialog({
                    title: '举报失败',
                    message: '请留下您的联系方式，方便我们与您进行联系',
                    theme: 'round-button',
                }).then(() => {
                    location.reload();
                });
            }else{
                this.$api.exposureSave({
                    params: {
                        memberId: this.$route.query.memberId,
                        phone: phone,
                        nickName: this.user.nickName,
                        contactInfo: this.user.phone,
                        type:'0',
                        title: title,
                        content: content,
                    },
                    success: function (res) {
                        if(res.code == 0){
                            history.back();
                        }else{
                            Dialog({
                                title: '举报失败',
                                message: res.msg,
                                theme: 'round-button',
                            }).then(() => {
                                location.reload();
                            });
                        }
                    }

                })
            }
        },
    }
};
